import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Input, Button, Label, InputGroup, InputGroupText, Spinner } from 'reactstrap';
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate, Link } from "react-router-dom";
import axios from 'axios';
import { FiMail, FiLock, FiKey, FiEye, FiEyeOff, FiChevronRight, FiArrowLeft } from 'react-icons/fi';
import NoSesssionAuthPage from '../../Layouts/Shared/_NoSesssionAuthPage';

const BRAND_COLOR = "#013682";

export default function ResetPassword2() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [email, setEMail] = useState('');
    const [otp, setOtp] = useState('');
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');

    const [password1Type, setPassword1Type] = useState('password');
    const [password2Type, setPassword2Type] = useState('password');
    const [apiCalled, setApiCalled] = useState(false);
    const [data, setData] = useState(null);

    useEffect(() => {
        if (data) {
            setApiCalled(false);
            if (data?.isSucceed === true) {
                toast.success(t('api.default.service.response.succeded'), { autoClose: 1000 });
                sessionStorage.removeItem("currentSession");
                setTimeout(() => {
                    navigate('/');
                }, 1500);
            } else {
                data?.messages?.forEach(item =>
                    toast.error(item.message, { autoClose: 5000 })
                );
            }
        }
    }, [data, t, navigate]);

    const callResetPass2 = (e) => {
        if (e) e.preventDefault();

        if (password1 === password2) {
            setApiCalled(true);
            const requestBody = {
                email: email,
                otp: otp,
                password1: password1,
                password2: password2
            };

            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            const ApiGateway = process.env.REACT_APP_API_URL;

            axios.post(ApiGateway + '/access/login/resetpass/step2', requestBody)
                .then(response => {
                    setData(response.data);
                })
                .catch(error => {
                    console.error(error);
                    setApiCalled(false);
                });
        } else {
            toast.warning(t('pages.register.form-notification.validation.is-not-equal-new-password-and-new-confirm-password'), { autoClose: 3000 });
        }
    };

    return (
        <NoSesssionAuthPage title={t('pages.reset-password-2.title')}>
            <ToastContainer />

            <div className="text-center text-lg-start mb-4">
                <h2 className="fw-bold mb-2" style={{ color: BRAND_COLOR }}>
                    {t('pages.reset-password-2.header')}
                </h2>
                <p className="text-muted small">
                    {t('pages.reset-password-2.description') || 'Doğrulama kodunu ve yeni şifrenizi girerek işlemi tamamlayın.'}
                </p>
            </div>

            <Form onSubmit={callResetPass2}>
                {/* Email Alanı */}
                <FormGroup className="mb-3">
                    <Label className="small fw-bold text-uppercase text-secondary">{t('pages.reset-password-2.form.label.email')}</Label>
                    <InputGroup className="corporate-input-group">
                        <InputGroupText className="bg-transparent border-end-0">
                            <FiMail size={18} className="text-muted" />
                        </InputGroupText>
                        <Input
                            type="email"
                            className="border-start-0 ps-0"
                            placeholder={t('pages.reset-password-2.form.placeholder.email')}
                            onChange={e => setEMail(e.target.value)}
                            required
                        />
                    </InputGroup>
                </FormGroup>

                {/* OTP Kod Alanı */}
                <FormGroup className="mb-3">
                    <Label className="small fw-bold text-uppercase text-secondary">{t('pages.reset-password-2.form.label.otp')}</Label>
                    <InputGroup className="corporate-input-group">
                        <InputGroupText className="bg-transparent border-end-0">
                            <FiKey size={18} className="text-muted" />
                        </InputGroupText>
                        <Input
                            type="text"
                            className="border-start-0 ps-0"
                            placeholder={t('pages.reset-password-2.form.placeholder.otp')}
                            onChange={e => setOtp(e.target.value)}
                            required
                        />
                    </InputGroup>
                </FormGroup>

                {/* Yeni Şifre */}
                <FormGroup className="mb-3">
                    <Label className="small fw-bold text-uppercase text-secondary">{t('pages.reset-password-2.form.label.password')}</Label>
                    <InputGroup className="corporate-input-group">
                        <InputGroupText className="bg-transparent border-end-0">
                            <FiLock size={18} className="text-muted" />
                        </InputGroupText>
                        <Input
                            type={password1Type}
                            className="border-start-0 border-end-0 ps-0"
                            placeholder={t('pages.reset-password-2.form.placeholder.password')}
                            onChange={e => setPassword1(e.target.value)}
                            required
                        />
                        <InputGroupText
                            className="bg-transparent border-start-0 cursor-pointer"
                            onClick={() => setPassword1Type(password1Type === 'password' ? 'text' : 'password')}
                            style={{ cursor: 'pointer' }}
                        >
                            {password1Type === 'password' ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                        </InputGroupText>
                    </InputGroup>
                </FormGroup>

                {/* Şifre Tekrar */}
                <FormGroup className="mb-4">
                    <Label className="small fw-bold text-uppercase text-secondary">{t('pages.reset-password-2.form.label.confirm-password')}</Label>
                    <InputGroup className="corporate-input-group">
                        <InputGroupText className="bg-transparent border-end-0">
                            <FiLock size={18} className="text-muted" />
                        </InputGroupText>
                        <Input
                            type={password2Type}
                            className="border-start-0 border-end-0 ps-0"
                            placeholder={t('pages.reset-password-2.form.placeholder.confirm-password')}
                            onChange={e => setPassword2(e.target.value)}
                            required
                        />
                        <InputGroupText
                            className="bg-transparent border-start-0 cursor-pointer"
                            onClick={() => setPassword2Type(password2Type === 'password' ? 'text' : 'password')}
                            style={{ cursor: 'pointer' }}
                        >
                            {password2Type === 'password' ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                        </InputGroupText>
                    </InputGroup>
                </FormGroup>

                <div className="d-flex justify-content-between align-items-center mb-4">
                    <Link to="/login" className="small text-decoration-none fw-bold d-flex align-items-center" style={{ color: BRAND_COLOR }}>
                        <FiArrowLeft className="me-1" /> {t('pages.reset-password-2.form.label.go-back-login')}
                    </Link>
                </div>

                <Button
                    block
                    size="lg"
                    disabled={apiCalled}
                    style={{ backgroundColor: BRAND_COLOR, borderColor: BRAND_COLOR }}
                    className="shadow"
                    type="submit"
                >
                    {apiCalled ? <Spinner size="sm" /> : <>{t('pages.reset-password-2.form.button.change')} <FiChevronRight className="ms-1" /></>}
                </Button>
            </Form>
        </NoSesssionAuthPage>
    );
}